export default function PressHero() {
  return (
    <section className="relative pt-32 pb-20 bg-gradient-to-br from-blue-50 to-green-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-4xl mx-auto">
          <div className="inline-flex items-center gap-2 bg-blue-100 text-blue-600 px-4 py-2 rounded-full text-sm font-medium mb-6">
            <i className="ri-newspaper-line"></i>
            Press & Media
          </div>
          <h1 className="text-5xl font-bold text-gray-900 mb-6">
            TrackVerse Newsroom
          </h1>
          <p className="text-xl text-gray-600 leading-relaxed">
            Stay updated with the latest news, press releases, and media coverage about 
            TrackVerse's innovations in global logistics and tracking solutions.
          </p>
        </div>
      </div>
    </section>
  );
}
